__turbopack_context__.v({
  "dropdown": "dropdown-module__ODka-a__dropdown",
  "option": "dropdown-module__ODka-a__option",
});
